import { render, staticRenderFns } from "./Pagination-400.vue?vue&type=template&id=56ab0e36&scoped=true"
import script from "./Pagination-400.vue?vue&type=script&lang=js"
export * from "./Pagination-400.vue?vue&type=script&lang=js"
import style0 from "./Pagination-400.vue?vue&type=style&index=0&id=56ab0e36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ab0e36",
  null
  
)

export default component.exports